/** fr — French stub. See pt-BR for rationale on partial coverage. */
import type enUS from "./en-US";
type EnResources = typeof enUS;
type DeepPartial<T> = { [K in keyof T]?: T[K] extends object ? DeepPartial<T[K]> : T[K] };

const fr: DeepPartial<EnResources> = {
  nav: {
    dashboard: "Tableau de bord",
    people: "Personnes",
    timeOff: "Congés",
    timeTracking: "Pointage",
    invoices: "Factures",
    approvals: "Approbations",
    recruiting: "Recrutement",
    performance: "Performance",
    assets: "Équipements",
    complaints: "Signalements",
    documents: "Documents",
    reports: "Rapports",
    aiAssistant: "Assistant IA",
    settings: "Paramètres",
    primary: "Principal",
    expandSidebar: "Développer le menu",
    collapseSidebar: "Réduire le menu",
    securityMfa: "Sécurité et MFA",
    logout: "Se déconnecter",
  },
  common: {
    loading: "Chargement…",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    close: "Fermer",
    search: "Rechercher",
    language: "Langue",
    timezone: "Fuseau horaire",
    currency: "Devise",
    accessDenied: "Accès refusé",
    accessDeniedBody: "Vous n'avez pas la permission de voir cette page.",
    retry: "Réessayer",
    noResults: "Aucun résultat",
  },
  auth: {
    welcomeBack: "Bon retour",
    signInSubtitle: "Connectez-vous à votre compte",
    tagline:
      "La plateforme RH intelligente que votre équipe a vraiment envie d'utiliser. Gérez les personnes, le temps et la culture — tout au même endroit.",
    demoHint: "Demo: admin@acme.com / demo1234",
    signIn: "Se connecter",
    email: "E-mail",
    password: "Mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    rememberMe: "Se souvenir de moi",
  },
  notifications: {
    title: "Notifications",
    markAllRead: "Tout marquer comme lu",
    empty: "Aucune notification pour l'instant.",
    justNow: "à l'instant",
    minutesAgo: "il y a {{count}} min",
    hoursAgo: "il y a {{count}} h",
    daysAgo: "il y a {{count}} j",
    unreadCountLabel: "Notifications, {{count}} non lues",
    unreadPrefix: "Non lu : {{title}}",
  },
  search: {
    placeholder: "Rechercher des personnes, documents, tâches…",
    groups: {
      pages: "Pages",
      people: "Personnes",
      documents: "Documents",
      tasks: "Tâches",
    },
  },
  settings: {
    preferences: "Préférences",
    preferencesHint:
      "Langue, fuseau horaire et devise utilisés dans toute l'application.",
    languageLabel: "Langue",
    timezoneLabel: "Fuseau horaire",
    currencyLabel: "Devise d'affichage",
  },
};

export default fr;
